/**
 * Immigration Dictionary
 * 
 * 入境事務處字典
 * 陸路邊境管制站等候時間
 */

const common = {
  title: {
    tc_name: '陸路口岸擠擁情況',
    en_name: 'Border Crossing Waiting Time',
  },
  hkResident: {
    tc_name: '香港居民',
    en_name: 'Hong Kong Resident',
  },
  visitor: {
    tc_name: '訪港旅客',
    en_name: 'Visitor',
  },
  waitingTime: {
    tc_name: '等候時間',
    en_name: 'Waiting Time',
  },
  lastUpdate: {
    tc_name: '最後更新',
    en_name: 'Last Update',
  },
  noData: {
    tc_name: '暫無資料',
    en_name: 'No Data Available',
  },
  error: {
    tc_name: '無法載入資料',
    en_name: 'Failed to Load Data',
  },
  refreshInterval: {
    tc_name: '每15分鐘更新',
    en_name: 'Updated every 15 minutes',
  },
};

// 管制站名稱映射（根據 API 文檔）
const controlPoints = {
  'HYW': {
    tc_name: '香園圍',
    en_name: 'Heung Yuen Wai',
  },
  'HZM': {
    tc_name: '港珠澳大橋',
    en_name: 'Hong Kong-Zhuhai-Macao-Bridge',
  },
  'LMC': {
    tc_name: '落馬洲',
    en_name: 'Lok Ma Chau',
  },
  'LSC': {
    tc_name: '落馬洲支線',
    en_name: 'Lok Ma Chau Spur Line',
  },
  'LWS': {
    tc_name: '羅湖',
    en_name: 'Lo Wu',
  },
  'MKT': {
    tc_name: '文錦渡',
    en_name: 'Man Kam To',
  },
  'SBC': {
    tc_name: '深圳灣',
    en_name: 'Shenzhen Bay',
  },
  'STK': {
    tc_name: '沙頭角',
    en_name: 'Sha Tau Kok',
  },
};

// 根據狀態碼獲取狀態（根據 API 文檔）
// Status code:
// 0: Normal
// 1: Busy
// 2: Very Busy
// 4: System Under Maintenance
// 99: Non Service Hours
const getWaitingStatus = (statusCode, isResident = true) => {
  switch (statusCode) {
    case 0:
      return {
        tc_name: '正常',
        en_name: 'Normal',
        color: '#4caf50',
        description: isResident 
          ? '一般少於 15 分鐘' 
          : '一般少於 30 分鐘',
        descriptionEn: isResident 
          ? 'Generally less than 15 mins'
          : 'Generally less than 30 mins',
      };
    case 1:
      return {
        tc_name: '繁忙',
        en_name: 'Busy',
        color: '#ff9800',
        description: isResident 
          ? '一般少於 30 分鐘' 
          : '一般少於 45 分鐘',
        descriptionEn: isResident 
          ? 'Generally less than 30 mins'
          : 'Generally less than 45 mins',
      };
    case 2:
      return {
        tc_name: '非常繁忙',
        en_name: 'Very Busy',
        color: '#f44336',
        description: isResident 
          ? '一般 30 分鐘或以上' 
          : '一般 45 分鐘或以上',
        descriptionEn: isResident 
          ? 'Generally 30 mins or above'
          : 'Generally 45 mins or above',
      };
    case 4:
      return {
        tc_name: '系統維護中',
        en_name: 'System Under Maintenance',
        color: '#9e9e9e',
        description: '系統維護中',
        descriptionEn: 'System Under Maintenance',
      };
    case 99:
      return {
        tc_name: '非服務時間',
        en_name: 'Non Service Hours',
        color: '#757575',
        description: '非服務時間',
        descriptionEn: 'Non Service Hours',
      };
    default:
      return {
        tc_name: '未知',
        en_name: 'Unknown',
        color: '#757575',
        description: '',
        descriptionEn: '',
      };
  }
};

// 等候時間狀態映射（保留舊的映射以兼容）
const waitingStatus = {
  '暢通': {
    tc_name: '暢通',
    en_name: 'Clear',
    color: '#4caf50',
  },
  '正常': {
    tc_name: '正常',
    en_name: 'Normal',
    color: '#2196f3',
  },
  '繁忙': {
    tc_name: '繁忙',
    en_name: 'Busy',
    color: '#ff9800',
  },
  '非常繁忙': {
    tc_name: '非常繁忙',
    en_name: 'Very Busy',
    color: '#f44336',
  },
};

const Immigration_Dict = {
  common,
  controlPoints,
  waitingStatus,
  getWaitingStatus,
};

export default Immigration_Dict;

